import { createContext, ReactNode, useContext, useState } from 'react'
import * as Types from '~/graphql/types'

const initialGeoLoc = { countryCode: '', latitude: 0, longitude: 0 }

interface GeoInfo {
  countryCode: string
  latitude: Types.Scalars['Float']
  longitude: Types.Scalars['Float']
}

const GeoInfoContext = createContext<GeoInfo>(initialGeoLoc as GeoInfo)
const GeoInfoConsumer = GeoInfoContext.Consumer

interface GeoInfoProviderProps {
  children: ReactNode
  geoInfo: GeoInfo
}

const GeoInfoProvider = ({
  children,
  geoInfo: initialGeoInfo = initialGeoLoc,
}: GeoInfoProviderProps) => {
  const [geoInfo] = useState<GeoInfo>(initialGeoInfo)

  return <GeoInfoContext.Provider value={geoInfo}>{children}</GeoInfoContext.Provider>
}

const useGeoInfo = () => useContext(GeoInfoContext)

export default GeoInfoContext

export { GeoInfoProvider, GeoInfoConsumer, useGeoInfo }
